module.exports = __webpack_public_path__ + "static/media/snowy-1-day.dd20fc9b.svg";